import colaboradorSchema from "../../schema/colaborador-schema";
// prettier-ignore
const inviteColaboradorSchema = colaboradorSchema.pick(["nome", "email", "gestao", "diagnostico", "incentivo", "configuracoes"]);

export default inviteColaboradorSchema;
